<p-treeselect
    [id]="id()"
    [ngModel]="isLoading() ? [] : selectedHierarchyNodes()"

    [options]="options()"

    [placeholder]="isLoading() ? 'Loading hierarchy...' : placeholder()"
    [loading]="isLoading()"
    
    
    [selectionMode]="selectionMode()"
    [metaKeySelection]="false"
    [filter]="true"

    [disabled]="isDisabled()"
    [invalid]="isInvalid()"
    [showClear]="true"

    fluid
    appendTo="body"

    (ngModelChange)="handleModelChange($event)"
    (onHide)="onHide()"
    (onClear)="onClear()"
    (onBlur)="blur.emit()"
    >
</p-treeselect>